export default __webpack_public_path__ + "static/percent-icon-6dde2262b7ab7ba089b63d33d5377bb2.svg";